import React, { Fragment } from 'react';
import { Dropdown, Input } from '@nackle/paper';
import companyService from '../../services/company';
import { EcardLoading } from '../../components/icons/icons.jsx';

import './company-select.less';

export default class CompanySelect extends React.Component {
  state = {
    companies: [],
    recentCompanies: [],
    selectedCompany: null,
    dropdownVisible: false
  };

  static getDerivedStateFromProps( props, state ) {
    if ( props.companyId === state.selectedCompany?.id ) {
      return null;
    }
    if ( !props.companyId && !state.selectedCompany ) {
      return null;
    }
    if ( !props.companyId && state.selectedCompany ) {
      return { selectedCompany: null };
    }
    const selectedCompany = state.companies.find(
      ( c ) => c.id === props.companyId
    );
    if ( selectedCompany ) {
      saveToRecentCompanies( selectedCompany );
      return {
        selectedCompany,
        recentCompanies: getRecentCompanies( state.companies )
      };
    }
    return { selectedCompany: null };
  }

  componentDidMount() {
    this.loadCompanies();
  }

  render() {
    const {
      companies,
      recentCompanies,
      // addCompanies,
      // viewCompanies,
      selectedCompany,
      dropdownVisible
    } = this.state;
    return (
      <>
        { this.state.companies.length === 0 && (
          <EcardLoading content="Loading Ecard Studio..."></EcardLoading>
        ) }
        { !this.props.isPrivate && (
          <Dropdown
            visible={ dropdownVisible }
            onVisibleChange={ this.handleDropDownVisibleChange }
            overlay={
              <CompanySelectMenu
                companies={
                  companies
                  // this.props.uploadPage
                  //   ? addCompanies
                  //   : this.props.isHeader
                  //   ? companies
                  //   : viewCompanies
                }
                recentCompanies={ recentCompanies }
                onChange={ this.handleCompanyChange }
              />
            }
            trigger={ [ 'click' ] }
            disabled={ this.props.disabled ? true : false }
          >
            <div className="company-select" onClick={ this.handleSelectClick }>
              { selectedCompany ? (
                <Fragment>
                  <img
                    className="company-select-logo"
                    src={ selectedCompany.primaryLogo }
                  />
                  <span>{ selectedCompany.name }</span>
                </Fragment>
              ) : this.props.isPrivate ? (
                <span>ALL</span>
              ) : (
                <span className="placeholder">select a company...</span>
              ) }
              { this.props.isHeader && <DownIcon className="down" /> }
            </div>
          </Dropdown>
        ) }
        { this.props.isPrivate && (
          <div className="company-select-all">GOLD-000</div>
        ) }
      </>
    );
  }

  handleDropDownVisibleChange = ( visible ) => {
    this.setState( { dropdownVisible: visible } );
  };

  handleCompanyChange = ( company ) => {
    const { onChange } = this.props;
    if ( typeof onChange === 'function' ) {
      onChange( company );
    }

    // if ( typeof logo === 'function' ) {
    //   logo( company.logo );
    // }
    this.setState( {
      filter: '',
      dropdownVisible: false
    } );
  };

  loadCompanies = async () => {
    try {
      const companies = await companyService.listCompanies();
      const recentCompanies = getRecentCompanies( companies );
      const addCompanies = getAddCompanyById( companies );
      const viewCompanies = getViewCompanyById( companies );

      this.setState( {
        companies,
        recentCompanies,
        addCompanies,
        viewCompanies
      } );
    } catch ( error ) {
      console.error( error );
      this.setState( { companies: [], recentCompanies: [] } );
    }
  };
}

function saveToRecentCompanies( company ) {
  if ( !localStorage ) {
    return;
  }

  let recentCompanies = localStorage.getItem( 'recent-companies' );
  if ( recentCompanies ) {
    recentCompanies = JSON.parse( recentCompanies );
  } else {
    recentCompanies = [];
  }

  // remove the current company, and limit it to the last 4
  recentCompanies = recentCompanies
    .filter( ( companyId ) => companyId !== company.id )
    .filter( ( companyId, index ) => index < 4 );

  localStorage.setItem(
    'recent-companies',
    JSON.stringify( [ company.id, ...recentCompanies ] )
  );
}

function getAddCompanyById( allCompanies ) {
  let addPrivate = localStorage.getItem( 'addPrivate' )
    ? localStorage.getItem( 'addPrivate' ).split( ',' )
    : [];
  return addPrivate
    .map( ( companyId ) =>
      allCompanies.find( ( company ) => companyId === company.id )
    )
    .filter( ( company ) => !!company );
}

function getViewCompanyById( allCompanies ) {
  let viewPrivate = localStorage.getItem( 'viewPrivate' )
    ? localStorage.getItem( 'viewPrivate' ).split( ',' )
    : [];
  return viewPrivate
    .map( ( companyId ) =>
      allCompanies.find( ( company ) => companyId === company.id )
    )
    .filter( ( company ) => !!company );
}
function getRecentCompanies( allCompanies ) {
  if ( !localStorage ) {
    return [];
  }
  let recentCompanies = localStorage.getItem( 'recent-companies' );
  if ( recentCompanies ) {
    recentCompanies = JSON.parse( recentCompanies );
  } else {
    recentCompanies = [];
  }

  return recentCompanies
    .map( ( companyId ) =>
      allCompanies.find( ( company ) => companyId === company.id )
    )
    .filter( ( company ) => !!company );
}

export const DownIcon = ( { ...props } ) => (
  <svg width="24" height="24" viewBox="0 0 24 24" { ...props }>
    <path d="M21.544 6.044l-9.544 9.541-9.544-9.541-1.416 1.416 10.25 10.25c0.194 0.194 0.45 0.294 0.706 0.294s0.513-0.097 0.706-0.294l10.25-10.25-1.409-1.416z"></path>
  </svg>
);

class CompanySelectMenu extends React.Component {
  constructor( props ) {
    super( props );
    this.state = {
      filter: '',
      filteredCompanies: []
    };
  }

  render() {
    const { filter, filteredCompanies } = this.state;
    const { companies, recentCompanies } = this.props;
    return (
      <div className="company-select-menu">
        <Input
          autoFocus
          className="company-select-filter"
          placeholder="search companies..."
          value={ filter }
          onKeyUp={ this.handleFilterKeyUp }
          onChange={ this.handleFilterChange }
          size="large"
        />
        <div className="company-select-list-container">
          { filter ? (
            <Fragment>
              <h2 className="company-select-header">Search Results</h2>
              { this.renderCompanyList( filteredCompanies ) }
            </Fragment>
          ) : (
            <Fragment>
              { recentCompanies.length > 0 && (
                <Fragment>
                  <h2 className="company-select-header">Recent Companies</h2>
                  { this.renderCompanyList( recentCompanies ) }
                </Fragment>
              ) }
              <h2 className="company-select-header">All Companies</h2>
              { this.renderCompanyList( companies ) }
            </Fragment>
          ) }
        </div>
      </div>
    );
  }
  renderCompanyList( companies ) {
    return (
      <ul className="company-select-list">
        { companies.map( ( company ) => (
          <li
            key={ company.id }
            className="company-select-list-item"
            onClick={ this.handleCompanyClick( company ) }
          >
            <span
              className="company-primary-color"
              style={ { backgroundColor: company.primaryColor || 'white' } }
            />
            <span
              className="company-secondary-color"
              style={ { backgroundColor: company.secondaryColor || 'white' } }
            />
            <span className="company-name">{ company.name }</span>
            <div className="company-select-list-item-logo-container">
              <img
                className="company-select-list-item-logo"
                src={ company.primaryLogo }
              />
            </div>
          </li>
        ) ) }
      </ul>
    );
  }

  handleFilterChange = ( e ) => {
    const { companies } = this.props;
    const filter = e.target.value;

    this.setState( {
      filter,
      filteredCompanies: filter
        ? companies.filter( ( company ) =>
            company.name.toLowerCase().includes( filter.toLowerCase() )
          )
        : []
    } );
  };
  handleFilterKeyUp = ( e ) => {
    const { filter, filteredCompanies } = this.props;

    if ( e.keyCode === 13 ) {
      if ( filter && filteredCompanies.length == 1 ) {
        this.handleCompanyClick( filteredCompanies[ 0 ] )( e );
      }
    } else if ( e.keyCode === 27 ) {
      this.handleSelectClick();
    }
  };
  handleCompanyClick = ( company ) => () => {
    const { onChange } = this.props;
    if ( typeof onChange === 'function' ) {
      onChange( company );
    }
    this.setState( {
      filter: ''
    } );
  };
}
